import get from 'lodash/get';

/*
 * This mixin gives the ability to a form-element to generate a link from a configuration
 */
export default {
  inject: {
    $parentForm: {
      default: null,
    },
  },
  methods: {
    processRouterParamValue(param) {
      return get(this.$parentForm, `value.${param}`, param);
    },
    generateRouterLink({ name, params }) {
      if (!name || !params) {
        return null;
      }

      return {
        name,
        params: Object.fromEntries(
          Object
            .entries(params)
            .map(([param, value]) => [param, this.processRouterParamValue(value)]),
        ),
      };
    },
  },
};
